import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/root.css";
import Logo from "../assets/images/anisija/anisija-logo.svg";
import { useLocale } from "../context/LocaleContext";

function Navbar() {
  const { t, lang, setLang } = useLocale();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        <img className="logo-img" src={Logo} alt="Anisija Logo" />
        <div className="navbar-title">
          <h1>Anisija</h1>
          <p>{t.nav.tagline}</p>
        </div>
      </Link>

      <button
        type="button"
        className="navbar-menu-toggle"
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
        aria-controls="navbar-navigation"
        onClick={() => setIsMenuOpen((prev) => !prev)}
      >
        ☰
      </button>

      <div
        id="navbar-navigation"
        className={`navbar-actions${isMenuOpen ? " open" : ""}`}
      >
        <div className="navbar-links">
          <Link
            to="/"
            className={`navbar-link${isActive("/") ? " active" : ""}`}
          >
            {t.nav.home}
          </Link>
          <Link
            to="/news"
            className={`navbar-link${isActive("/news") ? " active" : ""}`}
          >
            {t.nav.news}
          </Link>
          <Link
            to="/about"
            className={`navbar-link${isActive("/about") ? " active" : ""}`}
          >
            {t.nav.about}
          </Link>

          <div className={`navbar-documents${isActive("/documents") ? " active" : ""}`}>
            <span className="navbar-link navbar-documents-label">
              {t.nav.documents}
            </span>
            <div className="navbar-sublinks">
              <Link
                to="/documents/annual-reports"
                className={`navbar-link navbar-sublink${
                  isActive("/documents/annual-reports") ? " active" : ""
                }`}
              >
                {t.nav.annualReports}
              </Link>
              <Link
                to="/documents/projects"
                className={`navbar-link navbar-sublink${
                  isActive("/documents/projects") ? " active" : ""
                }`}
              >
                {t.nav.projects}
              </Link>
            </div>
          </div>
        </div>

        <div className="navbar-lang">
          <button
            type="button"
            onClick={() => setLang("mk")}
            className={`navbar-lang-option${lang === "mk" ? " active" : ""}`}
          >
            {t.nav.languages.mk}
          </button>
          <span className="navbar-lang-divider">|</span>
          <button
            type="button"
            onClick={() => setLang("en")}
            className={`navbar-lang-option${lang === "en" ? " active" : ""}`}
          >
            {t.nav.languages.en}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
